import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);
export default props => {
  const userId = window.CallNativeMethod && window.CallNativeMethod('get_user_id');
  const loginST = window.CallNativeMethod && window.CallNativeMethod('get_st');
  const [loginStatus, setLoginStatus] = useState(!!(loginST !== '' && userId));
  const userInfo = useSelector(selectUserInfo);
  const { getLoginStatus, callLoginPanel, resetLoginPanel } = props;

  const handleLogin = () => {
    // eslint-disable-next-line no-unused-expressions
    window.CallNativeMethod && window.CallNativeMethod('login'); // 未登录 调用登录弹窗
  };

  useEffect(() => {
    getLoginStatus(loginStatus);
  }, [loginStatus]);

  useEffect(() => {
    if (callLoginPanel) {
      handleLogin();
    }
    resetLoginPanel();
  }, [callLoginPanel]);

  // 写入登录状态;
  useEffect(() => {
    const userId = window.CallNativeMethod && window.CallNativeMethod('get_user_id');
    const loginST = window.CallNativeMethod && window.CallNativeMethod('get_st');
    if (loginST !== '' && userId) {
      // 登录
      setLoginStatus(true);
    } else {
      setLoginStatus(false);
    }
  }, [userInfo]);

  return <div></div>;
};
